import { getValidToken } from '../utils/tokenUtils';

export const fetchContracts = async () => {
  const token = await getValidToken();
  
  if (!token) {
    throw new Error('Ingen giltig inloggningssession. Logga in på nytt.');
  }
  
  const res = await fetch('/api/contracts', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    const err = new Error(`Kunde inte hämta kontrakt (${res.status}).` + (text ? ` - ${text}` : ''));
    err.status = res.status;
    throw err;
  }

  const data = await res.json();
  return Array.isArray(data) ? data : data.contracts || [];
};

export const fetchContractsForOrg = async (organisationId) => {
  const token = await getValidToken();

  if (!token) {
    throw new Error('Ingen giltig inloggningssession. Logga in på nytt.');
  }

  const params = new URLSearchParams({ organisationId });
  const res = await fetch(`/api/contracts/my-org?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    const err = new Error(`Kunde inte hämta kontrakt för organisationen (${res.status}).` + (text ? ` - ${text}` : ''));
    err.status = res.status;
    throw err;
  }

  const data = await res.json();
  return Array.isArray(data) ? data : [];
};
